import type { RestrictionReasonValue } from "@/bryntum-lib/models/MarketingAsset";

/**
 * Canonical frontend representation of a marketing asset from
 * GET /promote/board/{board_id}/marketing-assets.
 *
 * Matches the loadsync MarketingAsset payload. File display URLs from the API
 * are ignored — resolve via useFileUrl(asset.file) / presigned endpoints.
 */
export interface SwivuMarketingAsset {
  id: number;
  board: number;
  file: number;
  caption: string;
  altText: string;
  aiObservations: string[];
  visibilityWarnings: string[];
  isRestricted: boolean;
  restrictionReason: RestrictionReasonValue | null;
  tags: number[];
  createdAt: string;
  updatedAt: string;
  creator: number | null;
  updater: number | null;
}

export interface SwivuMarketingAssetApiResponse {
  id: number;
  board: number;
  file: number;
  caption: string;
  alt_text: string;
  ai_observations: string[];
  visibility_warnings: string[];
  is_restricted: boolean;
  restriction_reason: RestrictionReasonValue | null;
  tags: number[];
  created_at: string;
  updated_at: string;
  creator: number | null;
  updater: number | null;
  url?: string | null;
  thumbnail_url?: string | null;
}

export interface SwivuMarketingAssetListApiResponse {
  count: number;
  results: SwivuMarketingAssetApiResponse[];
}

export interface SwivuMarketingAssetListPage {
  count: number;
  results: SwivuMarketingAsset[];
}

export function mapApiMarketingAsset(raw: SwivuMarketingAssetApiResponse): SwivuMarketingAsset {
  return {
    id: raw.id,
    board: raw.board,
    file: raw.file,
    caption: raw.caption ?? "",
    altText: raw.alt_text ?? "",
    aiObservations: raw.ai_observations ?? [],
    visibilityWarnings: raw.visibility_warnings ?? [],
    isRestricted: raw.is_restricted ?? false,
    restrictionReason: raw.restriction_reason ?? null,
    tags: raw.tags ?? [],
    createdAt: raw.created_at,
    updatedAt: raw.updated_at,
    creator: raw.creator ?? null,
    updater: raw.updater ?? null,
  };
}
